module.exports = __webpack_public_path__ + "static/media/4.34b3c364.gif";